<template>
  <div class="winDialog1">
    <!-- top="100" -->
    <el-dialog
      :title="dialog.title"
      top="50px"
      :visible.sync="dialog.showEdit"
      :modal="true"
      :close-on-click-modal="false"
      width="80%"
      class="exhibition"
      @close="diaClose"
    >
      <div class="right-content box theme-color">
        <el-tabs style="height: 100%" v-model="activeName" type="card">
          <!-- v-if="visibleTab" -->
          <el-tab-pane label="计量点参数" name="info">
            <register-info
              v-if="selectedMeasure && activeName == 'info'"
              :measureId="selectedMeasure.measureId"
              :nodeData="nodeData"
              :measure="selectedMeasure"
              :viewId="viewId"
            ></register-info>
          </el-tab-pane>
          <el-tab-pane label="测量信息" name="second">
            <register-formula
              v-if="selectedMeasure && activeName == 'second'"
              :measureId="selectedMeasure.measureId"
            ></register-formula>
          </el-tab-pane>
          <el-tab-pane label="告警配置" name="third">
            <register-event
              v-if="selectedMeasure && activeName == 'third'"
              :templateId="selectedMeasure.measureTemplateId"
              :measureId="selectedMeasure.measureId"
            ></register-event>
          </el-tab-pane>
          <!-- <el-tab-pane label="容器配置11111" name="fourth">
            <register-container
              v-if="selectedMeasure && activeName == 'fourth'"
              :measureId="selectedMeasure.measureId"
            ></register-container>
          </el-tab-pane> -->
          <el-tab-pane label="测量点相册" name="five">
            <measure-img
              v-if="selectedMeasure && activeName == 'five'"
              :measureId="selectedMeasure.measureId"
            ></measure-img>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RegisterInfo from "@/components/page/register/info";
import RegisterFormula from "@/components/page/register/formula";
import RegisterContainer from "@/components/page/register/container";
import MeasureImg from "@/components/page/register/measureImg";
import RegisterEvent from "@/components/page/register/event";
export default {
  components: {
    RegisterInfo,
    RegisterFormula,
    RegisterContainer,
    MeasureImg,
    RegisterEvent,
  },
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {
          title: "编辑", //弹窗标题
          showEdit: false, //弹窗显示状态
        };
      },
    },
    selectedMeasure: {
      type: Object,
      default: () => {},
    },
    nodeData: {
      type: Object,
      default: () => {},
    },
    viewId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // visibleTab: false,
      activeName: "second",
      // activeName: "third",
    };
  },
  computed: {},
  methods: {
    /* 弹窗关闭 */
    diaClose() {
      this.dialog.diaClose = false;
      this.$emit("update:dialog", this.dialog);
    },
  },
};
</script>
<style lang="less" scoped>
.exhibition {
  text-align: left;
}
.right-content {
  width: 100%;
  height: 700px;
}
</style>
